import { forwardRef, memo } from "react";
import { iconVariants } from "../utils";
import { IconProps } from "../types";

export const StarknetColorIcon = memo(
  forwardRef<SVGSVGElement, IconProps>(
    ({ className, size, ...props }, forwardedRef) => (
      <svg
        viewBox="0 0 24 24"
        className={iconVariants({ size, className })}
        ref={forwardedRef}
        {...props}
      >
        <path fill="#29296E" d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
        <path
          fill="#FAFAFA"
          d="m16.188 9.593-.229-.707a.462.462 0 0 0-.304-.3l-.71-.218c-.099-.03-.1-.169-.002-.2l.707-.23a.463.463 0 0 0 .3-.304l.218-.71c.03-.098.169-.1.2-.001l.23.707c.046.143.16.255.304.3l.71.218c.099.03.1.169.002.2l-.707.229a.463.463 0 0 0-.3.305l-.218.71a.105.105 0 0 1-.2.001Z"
        />
        <path
          fill="#FF4F0A"
          d="M3.818 11.857c.214-.419.638-.735 1.077-.934a4.395 4.395 0 0 1 1.412-.358c.968-.088 1.911.074 2.77.354.443.132.839.315 1.248.5.199.096.386.204.578.309l.532.308c.583.358 1.15.675 1.681.92.533.245 1.015.41 1.469.494a3.49 3.49 0 0 0 1.482-.046c.564-.127 1.197-.402 1.859-.754.666-.353 1.35-.785 2.129-1.207a7.093 7.093 0 0 1-.719 2.51c-.4.79-.955 1.56-1.766 2.183a5.484 5.484 0 0 1-3 1.134c-1.112.075-2.17-.17-3.07-.539a10.104 10.104 0 0 1-2.377-1.408c-.191-.15-.294-.235-.435-.354l-.394-.345c-.266-.208-.523-.457-.786-.663-.524-.438-1.043-.877-1.612-1.258a6.916 6.916 0 0 0-.918-.532 3.976 3.976 0 0 0-.534-.204 2.198 2.198 0 0 0-.626-.11Z"
        />
        <path
          fill="#FAFAFA"
          d="M3.818 11.857c.11-.908.533-1.76 1.212-2.485a4.436 4.436 0 0 1 2.9-1.345 5.154 5.154 0 0 1 1.703.175c.537.149 1.04.366 1.493.621.226.128.438.269.65.41l.562.426.878.693c.57.454 1.113.873 1.616 1.22.507.347.94.6 1.352.75.41.161.926.203 1.61.031.338-.078.692-.22 1.07-.375.375-.159.764-.348 1.19-.535a4.91 4.91 0 0 1-.32 1.336 4.81 4.81 0 0 1-.704 1.246c-.16.191-.33.384-.53.561-.199.173-.42.338-.664.482a4.447 4.447 0 0 1-1.656.562 5.247 5.247 0 0 1-1.728-.078 6.952 6.952 0 0 1-1.496-.5 10.562 10.562 0 0 1-2.338-1.514c-.337-.28-.653-.573-.952-.87l-.354-.355a10.653 10.653 0 0 0-.32-.301c-.43-.38-.829-.67-1.268-.851-.436-.19-.994-.268-1.678-.14-.682.127-1.43.422-2.228.836ZM7.415 16.54a.487.487 0 1 1-.973 0 .487.487 0 0 1 .973 0Z"
        />
      </svg>
    ),
  ),
);

StarknetColorIcon.displayName = "StarknetColorIcon";
